import React from "react";
import { Info } from "@phosphor-icons/react";
import { PayloadCard } from "./LeadInfoTiles";

/** Original / normalized / delivered payload dumps. */
export default function LeadPayloads({ lead }) {
  return (
    <div className="brut-card mt-4 p-5">
      <div className="font-chivo font-bold uppercase tracking-tight mb-3 flex items-center gap-2">
        <Info size={16} /> Original payload / normalized / delivered
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-[11px] font-mono">
        <PayloadCard title="Original" v={lead.original_payload} />
        <PayloadCard title="Normalized" v={lead.normalized_data} />
        <PayloadCard title="Delivered" v={lead.delivered_data} />
      </div>
    </div>
  );
}
